import { z } from 'zod';

import { CompanyId, LosId, TaskId, TeamId, UserId } from '../BrandedIds';
import { TaskType } from '../tasks/Task';
import { TaskStatus } from '../tasks/TaskStatus';
import { zodTemporalInstant, zodTemporalPlainDate } from '../Temporal';
import { ExportableActor } from './util/ExportableActor';
import { lakeColumn } from './util/lakeColumn';

export const ExportableTask = z
  .object({
    id: TaskId,
    companyId: CompanyId,
    loanId: LosId.optional(),

    type: TaskType,
    status: TaskStatus,

    title: z.string().optional(),
    details: z.string(),

    dueDate: zodTemporalPlainDate.optional(),
    completedAt: zodTemporalInstant.optional(),

    assignees: lakeColumn(z.array(UserId).optional(), 'assignee_ids'),
    teamAssignees: lakeColumn(z.array(TeamId).optional(), 'team_assignee_ids'),
    createdBy: ExportableActor.optional(),

    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'Task' });

export type ExportableTask = z.infer<typeof ExportableTask>;
